import React from "react";
import { Link, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import _ from "lodash";
import { professionalAction, userActions } from "../../_actions";
import { AppTable } from "../../_components/AppTable";
import {
  Switch,
  Avatar,
  List,
  Button,
  Row,
  Col,
  Alert,
  Badge,
  Card,
  Table,
  Tag,
  Statistic,
  Modal,
  Drawer,
} from "antd";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  PieChart,
  Pie,
  Cell,
  LabelList,
  Label,
  LineChart,
  Line,
} from "recharts";
import {
  ApartmentOutlined,
  ApiOutlined,
  BellFilled,
  BellOutlined,
  ClearOutlined,
  DatabaseOutlined,
  DownOutlined,
  DeploymentUnitOutlined,
  EnvironmentOutlined,
  CameraOutlined,
  FileSearchOutlined,
  HistoryOutlined,
  MergeOutlined,
  QuestionCircleOutlined,
  SolutionOutlined,
  TeamOutlined,
  ToolOutlined,
  UpOutlined,
  UserOutlined,
  SearchOutlined,
  DownloadOutlined,
  EyeFilled,
} from "@ant-design/icons";
import "./Dashboard.css";
import { DatePicker, Spin } from "antd";
import moment from "moment";
import { AnalyticalDashboard } from "./AnalyticalDashboard";
import { WantedList } from "./wanted";
import { LanguageContext } from "../../context/LanguageContext";
import { roleAction } from "../../_actions/roleby.action";
import { notificationAction } from "../../_actions/notifications.actions";
import { PreventiveNotificationList } from "./PreventiveNotification";
import { PreventiveActionsNotSendNotificationList } from "./PreventiveActionsNotSendNotification";
import { adminService } from "../../_services/admin.service";
import { UserSnapShots } from "./UserSnapShots";
import { mapAdminCityAction } from "../../_actions/mapAdminCity.action";
import TokenBox from "./token";
import { adminServiceAction } from "../../_actions/admin.service";

/** map_cities is a JSON array of city ids, e.g. [1, 2, 3] */
const parseMapCityIds = (raw) => {
  let list = raw;
  if (typeof raw === "string") {
    const trimmed = raw.trim();
    if (!trimmed) return [];
    if (trimmed.startsWith("[") || trimmed.startsWith("{")) {
      try {
        list = JSON.parse(trimmed);
      } catch (e) {
        list = trimmed.split(",");
      }
    } else {
      list = trimmed.split(",");
    }
  }
  if (!Array.isArray(list)) {
    if (list && typeof list === "object") list = [list];
    else return [];
  }
  return list
    .map((item) => {
      if (item && typeof item === "object") {
        return Number(item.id ?? item.cityId ?? item.city_id);
      }
      return Number(String(item).trim());
    })
    .filter((n) => Number.isFinite(n));
};

class Dashboard extends React.Component {
  static contextType = LanguageContext;
  constructor(props) {
    super(props);
    this.state = {
      showWanted: false,
      isOn: false,
      selectedDates: {
        gps: moment().format("YYYY-MM"),
        prevention: moment().format("YYYY-MM"),
        twoPlus: moment().format("YYYY-MM"),
      },
      loading: false,
      gpsData: [],
      preventionData: [],
      twoPlusData: [],
      data: [],
      psData: [],
      is_prevention: false,
      online_users: [],
      loader: false,
      onlineUsersAccordionOpen: false,
      role2ModalVisible: false,
      selectedRole2Users: [],
      pModalVisible: false,
      ipDetails: [],
      ipModalVisible: false,
      selectedIpUserName: "",
      userDetailModalVisible: false,
      selectedUserDetail: null,
      cmisUtilsOpenGroup: null,
      viewSnapshot: false,
      selectedId: null,
      cityName: null,
      countLoading: false,
    };
    this.cardResultCache = {
      data: {},
      psData: {},
      mapAdminData: {},
    };
  }

  countValue = (value) => {
    if (value === null || value === undefined || value === "") {
      return 0;
    }
    return value;
  };

  rememberCardResult = (listKey, id, patch) => {
    this.cardResultCache[listKey][id] = {
      ...(this.cardResultCache[listKey][id] || {}),
      ...patch,
    };
  };

  applyCachedCardResults = (cards, listKey) => {
    const cache = this.cardResultCache[listKey] || {};
    return (cards || []).map((item) =>
      cache[item.id] ? { ...item, ...cache[item.id] } : item,
    );
  };

  commitCardResults = (listKey) => {
    this.setState((prev) => ({
      [listKey]: this.applyCachedCardResults(prev[listKey], listKey),
    }));
  };

  openSnapshot = (id, cityName) => {
    console.log("id", id);
    this.setState({
      viewSnapshot: true,
      selectedId: id,
      cityName: cityName,
    });
  };

  closeSnapsht = () => {
    this.setState({
      viewSnapshot: false,
      selectedId: null,
      cityName: null,
    });
  };

  toggleCmisUtilsGroup = (groupKey) => {
    this.setState((prevState) => ({
      cmisUtilsOpenGroup:
        prevState.cmisUtilsOpenGroup === groupKey ? null : groupKey,
    }));
  };

  openCmisUtilsUrl = (url) => {
    if (this.props.history?.push) {
      this.props.history.push(url);
    } else {
      window.location.href = url;
    }
  };

  OnlineCityWiseUserOnline = () => {
    this.setState({ loader: true });
    adminServiceAction.OnlineCityWiseUserOnline({}).then((res) => {
      this.setState({
        online_users: res.data,
        loader: false,
        online_user_count: res.total_online_users,
      });
    });
  };

  handleClick = () => {
    this.OnlineCityWiseUserOnline();
  };

  openIpDetailsModal = (userName, ipDetails) => {
    this.setState({
      selectedIpUserName: userName || "Login Details",
      ipDetails: Array.isArray(ipDetails) ? ipDetails : [],
      ipModalVisible: true,
    });
  };

  openUserDetailsModal = (record) => {
    this.setState({
      selectedUserDetail: record || null,
      userDetailModalVisible: true,
    });
  };
  getDistrictsid = () => {
    const { user } = this.props;
    console.log("users id", this.props);
    professionalAction.getDistrictsid(user.districtId).then((res) => {
      console.log("res", res);

      const tempData = res.pc_districts;
      console.log("text", tempData[0]?.DistrictName);
      this.setState({
        district_name: tempData[0]?.DistrictName,
      });
    });
  };
  onCityChange = (cityId, form) => {
    if (cityId) {
      this.props.dispatch(professionalAction.getDistrict(cityId, form));
    }
  };
  handleChange = (checked) => {
    console.log("checked", checked);
    this.setState({ isOn: checked });
  };
  componentDidUpdate(prevProps, prevState) {
    const prevLang = this.prevLanguage;
    const currentLang = this.context.language;
    console.log("currentLang=>", currentLang);
    if (prevLang !== currentLang) {
      console.log(`Language changed from ${prevLang} to ${currentLang}`);
      const { t, language } = this.context;

      const data =
        this.props.user.role != "8"
          ? [
              {
                id: 1,
                title: t("app_used"),
                bgColor: "#3B1A8F", // Deep Royal Purple
                result: null,
                icon: <UserOutlined />,
                url:
                  this.props.user && this.props.user.role === "8"
                    ? "/reportAppUsers"
                    : "/AppUserLogin",
              },
              {
                id: 2,
                title:
                  this.props.user &&
                  (this.props.user.role === "4" || this.props.user.role === "2")
                    ? t("registered_police_stations")
                    : "एकुण घटक",
                bgColor: "#00796B", // Teal Green
                result: null,
                icon: <ApartmentOutlined />,
                url: "/users",
              },
              {
                id: 3,
                title: t("total_accused"),
                bgColor: "#6A0DAD", // Rich Purple
                result: null,
                icon: <TeamOutlined />,
                url:
                  this.props.user && this.props.user.role === "8"
                    ? "/reportSupReport3"
                    : "/finds",
              },
              // hide for demo on date jan 27
              // {
              //   id: 4,
              //   title: t("accused_checked_today_in_GPS"),
              //   bgColor: "#0B5D2A", // Dark Government Green
              //   result: null,
              //   icon: <EnvironmentOutlined />,
              //   url:
              //     this.props.user && this.props.user.role === "8"
              //       ? "/reportSupReport4"
              //       : "/gps",
              // },
              {
                id: 5,
                title: t("preventive_action"),
                bgColor: "#C45500", // Burnt Orange
                result: null,
                icon: <FileSearchOutlined />,
                url: "/reportPreventive",
              },
              {
                id: 6,
                title: t("task_report"),
                bgColor: "#9B0000", // Dark Red / Maroon
                result: null,
                icon: <FileSearchOutlined />,
                url: "/reportPlus2Report",
              },
            ]
          : [
              {
                id: 1,
                title: t("app_used"),
                bgColor: "#3B1A8F", // Deep Royal Purple
                result: null,
                icon: <UserOutlined />,
                url:
                  this.props.user && this.props.user.role === "8"
                    ? "/reportAppUsers"
                    : "/AppUserLogin",
              },
              {
                id: 2,
                title:
                  this.props.user &&
                  (this.props.user.role === "4" || this.props.user.role === "2")
                    ? t("registered_police_stations")
                    : "एकुण घटक",
                bgColor: "#00796B", // Teal Green
                result: null,
                icon: <ApartmentOutlined />,
                url: "/users",
              },
              {
                id: 3,
                title: t("total_accused"),
                bgColor: "#6A0DAD", // Rich Purple
                result: null,
                icon: <TeamOutlined />,
                url:
                  this.props.user && this.props.user.role === "8"
                    ? "/reportSupReport3"
                    : "/finds",
              },
            ];

      this.setState({
        data: this.applyCachedCardResults(data, "data"),
      });

      const psData = [
        {
          id: 3,
          title: t("total_accused"),
          bgColor: "#6A0DAD",
          result: null,
          icon: <TeamOutlined />,
          url:
            this.props.user && this.props.user.role === "2"
              ? "/ProfessionalForm"
              : "/finds",
        },
        {
          id: 5,
          title: t("preventive_action"),
          bgColor: "#C45500",
          result: null,
          icon: <FileSearchOutlined />,
          url:
            this.props.user && this.props.user.role === "8"
              ? "/reportPreventive"
              : "/reportPreventive",
        },
        {
          id: 6,
          title: t("task_report"),
          bgColor: "#9B0000",
          result: null,
          icon: <FileSearchOutlined />,
          url:
            this.props.user && this.props.user.role === "2"
              ? "/reportPlus2Report"
              : "/reportPlus2Report",
        },
        {
          id: 7,
          title: t("arrest_register_report"),
          bgColor: "#00796B",
          result: null,
          icon: <FileSearchOutlined />,
          url:
            this.props.user && this.props.user.role === "2"
              ? "/reportArrest"
              : "/reportArrest",
        },
      ];
      this.setState({
        psData: this.applyCachedCardResults(psData, "psData"),
      });

      const mapAdminData = [
        {
          id: 3,
          title: t("total_accused"),
          bgColor: "#6A0DAD",
          result: null,
          icon: <TeamOutlined />,
          url: "/finds",
        },

        {
          id: 5,
          title: t("task_report"),
          bgColor: "#9B0000",
          result: null,
          icon: <FileSearchOutlined />,
          url: "/reportPlus2Report",
        },
        {
          id: 6,
          title: t("preventive_action"),
          bgColor: "#C45500",
          result: null,
          icon: <FileSearchOutlined />,
          url: "/reportPreventive",
        },
      ];
      this.setState({
        mapAdminData: this.applyCachedCardResults(mapAdminData, "mapAdminData"),
      });

      // you can also do other things here
    }
    this.prevLanguage = currentLang;
  }

  getAllCountsByMappedCities = () => {
    const temp = {
      map_cities: this.props.user.map_cities,
    };
    this.setState({ countLoading: true });
    mapAdminCityAction
      .getAllCountsByMappedCities(temp)
      .then((resp) => {
        console.log("resp", resp);
        this.totalMapDataUpdate(3, resp.totalCriminal);
        this.totalMapDataUpdate(6, {
          totalPreventiveActionCount: resp.totalPreventiveActionCount,
        });
        this.totalMapDataUpdate(5, {
          tottalTwoPlusCount: resp.twoPlusCount,
          completetottalTwoPlusCount: resp.completeTwoPlusCount,
        });
      })
      .catch((error) => {
        console.log("dashboard count error", error);
      })
      .finally(() => {
        this.setState({ countLoading: false });
      });
  };
  async componentDidMount() {
    const role = this.props?.user?.role;
    if (["2", "4", "8", "9", "10", "12"].includes(role)) {
      this.setState({ countLoading: true });
    }
    if (role === "2") {
      this.getDistrictsid();
    }
    if (this.props?.user.role === "8" || this.props?.user.role === "12") {
      this.OnlineCityWiseUserOnline();
    }
    this.props.dispatch(professionalAction.getCity());
    console.log("this.props", this.props);
    this.prevLanguage = this.context.language;
    console.log("prevLanguage=>", this.prevLanguage);
    const { t, language } = this.context;
    const data =
      this.props.user.role != "8"
        ? [
            {
              id: 1,
              title: t("app_used"),
              bgColor: "#3B1A8F", // Deep Royal Purple
              result: null,
              icon: <UserOutlined />,
              url:
                this.props.user && this.props.user.role === "8"
                  ? "/reportAppUsers"
                  : "/AppUserLogin",
            },
            {
              id: 2,
              title:
                this.props.user &&
                (this.props.user.role === "4" || this.props.user.role === "2")
                  ? t("registered_police_stations")
                  : "एकुण घटक",
              bgColor: "#00796B", // Teal Green
              result: null,
              icon: <ApartmentOutlined />,
              url: "/users",
            },
            {
              id: 3,
              title: t("total_accused"),
              bgColor: "#6A0DAD", // Rich Purple
              result: null,
              icon: <TeamOutlined />,
              url:
                this.props.user && this.props.user.role === "8"
                  ? "/reportSupReport3"
                  : "/finds",
            },
            // hide for demo on date jan 27
            // {
            //   id: 4,
            //   title: t("accused_checked_today_in_GPS"),
            //   bgColor: "#0B5D2A", // Dark Government Green
            //   result: null,
            //   icon: <EnvironmentOutlined />,
            //   url:
            //     this.props.user && this.props.user.role === "8"
            //       ? "/reportSupReport4"
            //       : "/gps",
            // },
            {
              id: 5,
              title: t("preventive_action"),
              bgColor: "#C45500", // Burnt Orange
              result: null,
              icon: <FileSearchOutlined />,
              url: "/reportPreventive",
            },
            {
              id: 6,
              title: t("task_report"),
              bgColor: "#9B0000", // Dark Red / Maroon
              result: null,
              icon: <FileSearchOutlined />,
              url: "/reportPlus2Report",
            },
          ]
        : [
            {
              id: 1,
              title: t("app_used"),
              bgColor: "#3B1A8F", // Deep Royal Purple
              result: null,
              icon: <UserOutlined />,
              url:
                this.props.user && this.props.user.role === "8"
                  ? "/reportAppUsers"
                  : "/AppUserLogin",
            },
            {
              id: 2,
              title:
                this.props.user &&
                (this.props.user.role === "4" || this.props.user.role === "2")
                  ? t("registered_police_stations")
                  : "एकुण घटक",
              bgColor: "#00796B", // Teal Green
              result: null,
              icon: <ApartmentOutlined />,
              url: "/users",
            },
            {
              id: 3,
              title: t("total_accused"),
              bgColor: "#6A0DAD", // Rich Purple
              result: null,
              icon: <TeamOutlined />,
              url:
                this.props.user && this.props.user.role === "8"
                  ? "/reportSupReport3"
                  : "/finds",
            },
          ];

    this.setState({
      data: this.applyCachedCardResults(data, "data"),
    });
    const psData = [
      {
        id: 3,
        title: t("total_accused"),
        bgColor: "#6A0DAD",
        result: null,
        icon: <TeamOutlined />,
        url:
          this.props.user && this.props.user.role === "2"
            ? "/ProfessionalForm"
            : "/finds",
      },
      {
        id: 5,
        title: t("preventive_action"),
        bgColor: "#C45500",
        result: null,
        icon: <FileSearchOutlined />,
        url:
          this.props.user && this.props.user.role === "8"
            ? "/reportPreventive"
            : "/reportPreventive",
      },
      {
        id: 6,
        title: t("task_report"),
        bgColor: "#9B0000",
        result: null,
        icon: <FileSearchOutlined />,
        url:
          this.props.user && this.props.user.role === "2"
            ? "/reportPlus2Report"
            : "/reportPlus2Report",
      },
      {
        id: 7,
        title: t("arrest_register_report"),
        bgColor: "#00796B",
        result: null,
        icon: <FileSearchOutlined />,
        url:
          this.props.user && this.props.user.role === "2"
            ? "/reportArrest"
            : "/reportArrest",
      },
    ];
    this.setState({
      psData: this.applyCachedCardResults(psData, "psData"),
    });

    const mapAdminData = [
      {
        id: 3,
        title: t("total_accused"),
        bgColor: "#6A0DAD",
        result: null,
        icon: <TeamOutlined />,
        url: "/finds",
      },

      {
        id: 5,
        title: t("task_report"),
        bgColor: "#9B0000",
        result: null,
        icon: <FileSearchOutlined />,
        url: "/reportPlus2Report",
      },
      {
        id: 6,
        title: t("preventive_action"),
        bgColor: "#C45500",
        result: null,
        icon: <FileSearchOutlined />,
        url: "/reportPreventive",
      },
    ];
    this.setState({
      mapAdminData: this.applyCachedCardResults(mapAdminData, "mapAdminData"),
    });

    if (role && role === "2") {
      this.getDashboardCount();
    }
    if ((role && role === "9") || (role && role === "10")) {
      this.getAllCountByRole();
    }
    if ((role && role === "4") || (role && role === "8")) {
      this.getAllCount();
    }
    if (role && role === "12") {
      this.getAllCountsByMappedCities();
    }
  }

  getDashboardCount() {
    const { districtId } = this.props.user;
    this.setState({ countLoading: true });
    professionalAction
      .getDashboardCount(districtId)
      .then((res) => (res && res.json ? res.json() : null))
      .then((resp) => {
        if (!resp) return;
        console.log("resp", resp);
        this.totalPSDataUpdate(3, resp);
        this.totalPSDataUpdate(5, {
          totalCurrentCount: resp.totalCurrentCount,
          totalPreventiveActionCount: resp.totalPreventiveActionCount,
        });
        this.totalPSDataUpdate(6, {
          tottalTwoPlusCount: resp.tottalTwoPlusCount,
          completetottalTwoPlusCount: resp.completetottalTwoPlusCount,
        });
        this.totalPSDataUpdate(7, {
          totalarrescount: resp.totalarrescount,
        });
      })
      .catch((error) => {
        console.log("dashboard count error", error);
      })
      .finally(() => {
        this.setState({ countLoading: false });
      });
  }
  getAllCountByRole() {
    const temp = {
      districtId: this.props.user.map_districtId,
    };
    this.setState({ countLoading: true });
    roleAction
      .getAllCountByRole(temp)
      .then((res) => (res && res.json ? res.json() : null))
      .then((resp) => {
        if (!resp) return;
        console.log("resp", resp);
        this.totalPSDataUpdate(3, resp);
        this.totalPSDataUpdate(5, {
          totalCurrentCount: resp.totalCurrentCount,
          totalPreventiveActionCount: resp.totalPreventiveActionCount,
        });
        this.totalPSDataUpdate(6, {
          tottalTwoPlusCount: resp.tottalTwoPlusCount,
          completetottalTwoPlusCount: resp.completetottalTwoPlusCount,
        });
        this.totalPSDataUpdate(7, {
          totalarrescount: resp.totalarrescount,
        });
      })
      .catch((error) => {
        console.log("dashboard count error", error);
      })
      .finally(() => {
        this.setState({ countLoading: false });
      });
  }

  getAllCount() {
    const { cityId, role } = this.props.user;
    this.setState({ countLoading: true });
    if (role === "4") {
      professionalAction
        .getAllCount(role, cityId)
        .then((res) => (res && res.json ? res.json() : null))
        .then((resp) => {
          if (!resp) return;
          this.totalDataUpdate(1, {
            totalAppUser: resp.totalAppUser,
            totalAPPUserPending: resp.totalAPPUserPending,
            totalAPPUserReject: resp.totalAPPUserReject,
          });
          this.totalDataUpdate(2, resp.totalRegisterPoliceStationCount);
          this.totalDataUpdate(3, resp.totalCriminal);
          this.totalDataUpdate(4, resp.totalTodayGPSCount);
          this.totalDataUpdate(5, {
            totalCurrentCount: resp.totalCurrentCount,
            totalPreventiveActionCount: resp.totalPreventiveActionCount,
          });
          this.totalDataUpdate(6, {
            tottalTwoPlusCount: resp.tottalTwoPlusCount,
            completetottalTwoPlusCount: resp.completetottalTwoPlusCount,
          });
        })
        .catch((error) => {
          console.log("dashboard count error", error);
        })
        .finally(() => {
          this.setState({ countLoading: false });
        });
      // professionalAction.getTotalCriminalCount(role, cityId).then((res) => {
      //   res &&
      //     res &&
      //     res.json().then((resp) => {
      //       this.totalDataUpdate(3, resp);
      //     });
      // });
      // professionalAction
      //   .getTotalRegisterPoliceStationCount(role, cityId)
      //   .then((res) => {
      //     res &&
      //       res &&
      //       res.json().then((resp) => {
      //         this.totalDataUpdate(2, resp);
      //       });
      //   });
      // professionalAction.getTotalTodayGPSCount(role, cityId).then((res) => {
      //   res &&
      //     res &&
      //     res.json().then((resp) => {
      //       this.totalDataUpdate(4, resp);
      //     });
      // });
    } else {
      professionalAction
        .getAllCount(role, cityId)
        .then((res) => (res && res.json ? res.json() : null))
        .then((resp) => {
          if (!resp) return;
          this.totalDataUpdate(1, { totalAppUser: resp.totalAppUser });
          this.totalDataUpdate(2, resp.totalRegisterPoliceStationCount);
          this.totalDataUpdate(3, resp.totalCriminal);
          this.totalDataUpdate(4, resp.totalTodayGPSCount);
        })
        .catch((error) => {
          console.log("dashboard count error", error);
        })
        .finally(() => {
          this.setState({ countLoading: false });
        });
    }
  }

  totalPSDataUpdate = (id, resp) => {
    let patch = { result: this.countValue(resp) };
    if (id == 3) {
      patch = { result: `${this.countValue(resp.count)}` };
    } else if (id == 5) {
      patch = {
        result: `${this.countValue(resp.totalCurrentCount)} / ${this.countValue(resp.totalPreventiveActionCount)}`,
        totalCurrentCount: this.countValue(resp.totalCurrentCount),
        totalPreventiveActionCount: this.countValue(
          resp.totalPreventiveActionCount,
        ),
      };
    } else if (id == 6) {
      patch = {
        result: `${this.countValue(resp.completetottalTwoPlusCount)}`,
        tottalTwoPlusCount: this.countValue(resp.tottalTwoPlusCount),
        completetottalTwoPlusCount: this.countValue(
          resp.completetottalTwoPlusCount,
        ),
      };
    } else if (id == 7) {
      patch = {
        result: `${this.countValue(resp.totalarrescount)}`,
        totalarrescount: this.countValue(resp.totalarrescount),
      };
    }
    this.rememberCardResult("psData", id, patch);
    this.commitCardResults("psData");
  };

  totalDataUpdate = (id, resp) => {
    let patch = { result: this.countValue(resp) };
    if (id == 1) {
      patch = { result: `${this.countValue(resp.totalAppUser)}` };
    } else if (id === 5) {
      patch = {
        result: `${this.countValue(resp.totalCurrentCount)} / ${this.countValue(resp.totalPreventiveActionCount)}`,
        totalCurrentCount: this.countValue(resp.totalCurrentCount),
        totalPreventiveActionCount: this.countValue(
          resp.totalPreventiveActionCount,
        ),
      };
    } else if (id === 6) {
      patch = {
        result: `${this.countValue(resp.completetottalTwoPlusCount)}`,
        tottalTwoPlusCount: this.countValue(resp.tottalTwoPlusCount),
        completetottalTwoPlusCount: this.countValue(
          resp.completetottalTwoPlusCount,
        ),
      };
    }
    this.rememberCardResult("data", id, patch);
    this.commitCardResults("data");
  };
  totalMapDataUpdate = (id, resp) => {
    let patch = { result: this.countValue(resp) };
    if (id == 1) {
      patch = { result: `${this.countValue(resp.totalAppUser)}` };
    } else if (id === 5) {
      patch = {
        result: `${this.countValue(resp.completetottalTwoPlusCount)}`,
        tottalTwoPlusCount: this.countValue(resp.tottalTwoPlusCount),
        completetottalTwoPlusCount: this.countValue(
          resp.completetottalTwoPlusCount,
        ),
      };
    } else if (id === 6) {
      patch = {
        result: `${this.countValue(resp.totalPreventiveActionCount)}`,
        totalCurrentCount: this.countValue(resp.totalCurrentCount),
        totalPreventiveActionCount: this.countValue(
          resp.totalPreventiveActionCount,
        ),
      };
    }
    this.rememberCardResult("mapAdminData", id, patch);
    this.commitCardResults("mapAdminData");
  };

  gotToPages(url) {
    if (url === "/reportPreventive") {
      this.props.history.push({
        pathname: url,
        state: { dashboardFlag: true },
      });
    } else if (url === "/reportPlus2Report") {
      this.props.history.push({
        pathname: url,
        state: { Plus2Report: true },
      });
    } else {
      this.props.history.push(url);
    }
  }

  closeWanted = () => {
    this.setState({ showWanted: false, is_prevention: false });
  };
  render() {
    const {
      isOn,
      psData,
      showWanted,
      is_prevention,
      online_users,
      online_user_count,
    } = this.state;
    const { language, t } = this.context;
    console.log("psData", psData);
    console.log("this props dashboard", this.props);
    const columns = [
      {
        title: "Sr.No",
        key: "srno",
        render: (_, __, index) => index + 1,
      },
      {
        title: "Name",
        dataIndex: "name",
        sorter: (a, b) => a.name.localeCompare(b.name),
        render: (text, record) => (
          <Button type="link" onClick={() => this.openUserDetailsModal(record)}>
            {text}
          </Button>
        ),
      },
      {
        title: "Phone",
        dataIndex: "phone",
        sorter: (a, b) => a.phone.localeCompare(b.phone),
      },
      {
        title: "City",
        dataIndex: "City",
        sorter: (a, b) => a.City.localeCompare(b.City),
      },
      {
        title: "IP Address",
        dataIndex: "ip_address",
        sorter: (a, b) => a.ip_address.localeCompare(b.ip_address),
      },
      {
        title: "Status",
        dataIndex: "online_status",
        sorter: (a, b) => a.online_status.localeCompare(b.online_status),
        render: (text, record) => (
          <Button
            type={text === "ONLINE" ? "primary" : "default"}
            danger={text === "OFFLINE"}
            onClick={() => {
              this.openIpDetailsModal(
                record?.name,
                record?.latest_5_ip_details || [],
              );
            }}
          >
            {text}
          </Button>
        ),
      },
      {
        title: "Action",
        key: "action",
        render: (_, record) => (
          <Button
            type="primary"
            disabled={record.role_2_online_users.length === 0}
            onClick={() => {
              this.setState({
                selectedRole2Users: record.role_2_online_users || [],
                role2ModalVisible: true,
              });
            }}
          >
            {record.role_2_online_users.length}
          </Button>
        ),
      },
      {
        title: "Report",
        dataIndex: "report",
        render: (text, record) => (
          <>
            <Button
              type="primary"
              onClick={() => {
                this.openSnapshot(record.cityId, record.City);
              }}
            >
              <EyeFilled />
            </Button>
          </>
        ),
      },
    ];
    const cmisUtilsGroups = [
      {
        key: "data-add-mapping",
        title: "Data Add / Mapping",
        icon: <DatabaseOutlined />,
        color: "#1677ff",
        items: [
          {
            title: "Act/Section",
            url: "/act-section",
            icon: <FileSearchOutlined />,
            color: "#1677ff",
          },
          {
            title: "States",
            url: "/states",
            icon: <EnvironmentOutlined />,
            color: "#13a8a8",
          },
          {
            title: "CCTNS Districts",
            url: "/cctns-districts-map",
            icon: <EnvironmentOutlined />,
            color: "#08979c",
          },
          {
            title: "CCTNS Missing",
            url: "/cctns-missing",
            icon: <EnvironmentOutlined />,
            color: "#08979c",
          },
          {
            title: t("modus_operandi"),
            url: "/modas",
            icon: <SolutionOutlined />,
            color: "#d46b08",
          },
          {
            title: "Sub City",
            url: "/sub-cities",
            icon: <EnvironmentOutlined />,
            color: "#389e0d",
          },
          {
            title: "Profile Merge ",
            url: "/allocation-guna-merge",
            icon: <MergeOutlined />,
            color: "#cf1322",
          },
          {
            title: "Face Search Allocation",
            url: "/face-search-allocation",
            icon: <FileSearchOutlined />,
            color: "#096dd9",
          },
          {
            title: "Third Party Image Provision",
            url: "/image-provision",
            icon: <CameraOutlined />,
            color: "#087f70",
          },
          {
            title: "Add Api",
            url: "/api-manager",
            icon: <ApiOutlined />,
            color: "#1d39c4",
          },
          {
            title: "API Details",
            url: "/api-details",
            icon: <ApiOutlined />,
            color: "#2f54eb",
          },
        ],
      },
      {
        key: "record-cleaning",
        title: "Record Cleaning",
        icon: <ClearOutlined />,
        color: "#cf1322",
        items: [
          {
            title: "Repeated Crime List",
            url: "/douable-cr",
            icon: <SearchOutlined />,
            color: "#722ed1",
          },
          {
            title: "Crime Delete Request",
            url: "/guna-hide",
            icon: <DeploymentUnitOutlined />,
            color: "#722ed1",
          },
          {
            title: "Duplicate name List",
            url: "/fuzzy",
            icon: <SearchOutlined />,
            color: "#1677ff",
          },
          {
            title: "Profile with Zero crime",
            url: "/crime-null",
            icon: <SearchOutlined />,
            color: "#1677ff",
          },
        ],
      },
      {
        key: "log",
        title: "Log",
        icon: <HistoryOutlined />,
        color: "#c41d7f",
        items: [
          {
            title: "Album Logs",
            url: "/logs",
            icon: <HistoryOutlined />,
            color: "#c41d7f",
          },
          {
            title: "Cctv log",
            url: "/api-log",
            icon: <DeploymentUnitOutlined />,
            color: "#531dab",
          },
        ],
      },
    ];
    const openCmisUtilsGroup = cmisUtilsGroups.find(
      (group) => group.key === this.state.cmisUtilsOpenGroup,
    );

    const isMappedCityRole = this.props.user?.role === "12";
    const mappedCityIds = isMappedCityRole
      ? parseMapCityIds(this.props.user?.map_cities)
      : [];
    const visibleOnlineUsers = isMappedCityRole
      ? (online_users || []).filter((row) =>
          mappedCityIds.includes(Number(row?.cityId)),
        )
      : online_users || [];
    const totalOnlineUsers = isMappedCityRole
      ? visibleOnlineUsers.reduce((sum, row) => {
          const cityAdminOnline = row?.online_status === "ONLINE" ? 1 : 0;
          const stationOnline = Array.isArray(row?.role_2_online_users)
            ? row.role_2_online_users.length
            : 0;
          return sum + cityAdminOnline + stationOnline;
        }, 0)
      : online_user_count || 0;
    return (
      <>
        <div className="dashboard-card-wrapper">
          {["2", "9", "10", "12"].includes(this.props.user.role) && (
            <>
              <Row
                justify="end" // Aligns content to the end (right)
                style={{ marginBottom: "10px" }}
              >
                {!isOn && !showWanted && (
                  <Col>
                    <Button
                      type="primary"
                      className="d-flex justify-content-end"
                      onClick={() => this.setState({ showWanted: true })}
                      style={{ marginLeft: 8 }}
                    >
                      {t("wanted")}
                    </Button>
                  </Col>
                )}
              </Row>
            </>
          )}
          {showWanted == true || is_prevention === true ? (
            ""
          ) : (
            <>
              <Row
                justify="space-between"
                align="middle"
                style={{ marginBottom: "10px" }}
              >
                {(this.props.user.role === "4" ||
                  this.props.user.role === "9" ||
                  this.props.user.role === "10") && (
                  <>
                    <Col>
                      <div className="switch-btn">
                        <Switch
                          checked={!!isOn}
                          onChange={(e) => this.handleChange(e)}
                          style={{ marginRight: "10px" }}
                        />
                        <div>
                          {isOn
                            ? t("switch_to_normal_view")
                            : t("switch_to_analytical_view")}
                        </div>
                      </div>
                    </Col>
                  </>
                )}
                {isOn == false && showWanted == false && (
                  <Col
                    className={
                      this.props.user.role == 2 && "d-flex justify-content-end"
                    }
                  >
                    {this.props.user.role === "4" && (
                      <Button
                        type="primary"
                        className="d-flex justify-content-end"
                        onClick={() => {
                          this.setState({ showWanted: true });
                        }}
                        style={{ marginLeft: 8 }}
                      >
                        {t("wanted")}
                      </Button>
                    )}
                  </Col>
                )}
              </Row>
            </>
          )}

          {showWanted ? (
            <WantedList
              {...this.props}
              closeWanted={this.closeWanted}
              onCityChange={this.onCityChange}
              DistrictName={this.state.district_name}
              user={this.props.user}
              pc_cities={this.props.professionals.pc_cities}
              professionals={this.props.professionals}
            />
          ) : (
            <>
              {isOn && isOn === true ? (
                <AnalyticalDashboard {...this.props} isOn={this.state.isOn} />
              ) : (this.props.user.role === "9" ||
                  this.props.user.role == "10") &&
                !Array.isArray(this.props.user.map_districtId) ? (
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    minHeight: 180,
                    padding: 16,
                  }}
                >
                  <div
                    style={{
                      maxWidth: 420,
                      width: "100%",
                      background: "#fff",
                      borderRadius: 12,
                      boxShadow: "0 2px 12px #e0e0e0",
                      padding: 32,
                      textAlign: "center",
                    }}
                  >
                    <h2 style={{ marginBottom: 16, color: "#333" }}>
                      Please select police station
                    </h2>
                    <div
                      style={{ marginBottom: 18, color: "#666", fontSize: 16 }}
                    >
                      Please select from the following URLs:
                    </div>
                    <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                      <li style={{ margin: "14px 0" }}>
                        <Link
                          to="/map-police-station"
                          style={{
                            fontSize: 16,
                            color: "#1890ff",
                            textDecoration: "underline",
                          }}
                        >
                          Registered Police Stations
                        </Link>
                      </li>
                      {/* Add more links here if needed */}
                    </ul>
                  </div>
                </div>
              ) : (
                <>
                  <List
                    itemLayout="horizontal"
                    dataSource={
                      this.props.user.role === "2"
                        ? _.sortBy(this.state.psData, "id")
                        : this.props.user.role === "4"
                          ? _.sortBy(this.state.data, "id")
                          : this.props.user.role === "9" ||
                              this.props.user.role === "10"
                            ? _.sortBy(this.state.psData, "id")
                            : this.props.user.role === "12"
                              ? _.sortBy(this.state.mapAdminData, "id")
                              : _.sortBy(this.state.data, "id")
                    }
                    renderItem={(item) => (
                      <List.Item
                        style={{ display: "inline-block", width: "33%" }}
                        onClick={() => {
                          this.gotToPages(item.url);
                        }}
                      >
                        <List.Item.Meta
                          style={{
                            color: "#ffff",
                            backgroundColor: item.bgColor,
                            padding: "15px",
                            margin: "10px",
                            boxShadow: "2px 2px 5px 0px #797979",
                          }}
                          avatar={
                            <Avatar
                              style={{
                                backgroundColor: "#fff",
                                color: item.bgColor,
                              }}
                              icon={item.icon}
                            />
                          }
                          title={item.title}
                          description={
                            item.result !== null &&
                            item.result !== undefined &&
                            item.result !== ""
                              ? item.result
                              : "0"
                          }
                        />
                      </List.Item>
                    )}
                  />
                  {!["8", "12"].includes(this.props.user.role) && (
                    <UserSnapShots />
                  )}
                </>
              )}
            </>
          )}
        </div>
        {this.state.countLoading && (
          <div className="dashboard-bottom-loader">
            <Spin size="large" />
          </div>
        )}
        {this.props.user.role === "8" && (
          <div>
            <Card
              style={{
                marginBottom: 20,
                borderRadius: 10,
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 10,
                  fontSize: 18,
                  fontWeight: 600,
                  marginBottom: 16,
                }}
              >
                <ToolOutlined style={{ color: "#1677ff" }} />
                CMIS Utils
              </div>
              <Row gutter={[16, 16]}>
                {cmisUtilsGroups.map((group) => {
                  const isOpen = this.state.cmisUtilsOpenGroup === group.key;
                  return (
                    <Col xs={24} sm={12} md={8} key={group.key}>
                      <Card
                        hoverable
                        onClick={() => this.toggleCmisUtilsGroup(group.key)}
                        style={{
                          borderRadius: 12,
                          border: isOpen
                            ? `1px solid ${group.color}`
                            : "1px solid #f0f0f0",
                          boxShadow: isOpen
                            ? `0 4px 12px ${group.color}22`
                            : "none",
                          minHeight: 110,
                          cursor: "pointer",
                          background: isOpen ? `${group.color}08` : "#fff",
                        }}
                        bodyStyle={{
                          padding: 16,
                          display: "flex",
                          flexDirection: "column",
                          gap: 10,
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                          }}
                        >
                          <div
                            style={{
                              width: 42,
                              height: 42,
                              borderRadius: 12,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              background: `${group.color}12`,
                              color: group.color,
                              fontSize: 20,
                            }}
                          >
                            {group.icon}
                          </div>
                          {isOpen ? (
                            <UpOutlined
                              style={{ fontSize: 12, color: group.color }}
                            />
                          ) : (
                            <DownOutlined
                              style={{ fontSize: 12, color: "#8c8c8c" }}
                            />
                          )}
                        </div>
                        <div
                          style={{
                            fontSize: 14,
                            fontWeight: 600,
                            color: "#262626",
                            lineHeight: 1.45,
                          }}
                        >
                          {group.title}
                        </div>
                      </Card>
                    </Col>
                  );
                })}
              </Row>
              {openCmisUtilsGroup && (
                <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
                  {openCmisUtilsGroup.items.map((item) => (
                    <Col xs={24} sm={12} md={8} lg={6} key={item.url}>
                      <Card
                        hoverable
                        onClick={() => this.openCmisUtilsUrl(item.url)}
                        style={{
                          borderRadius: 12,
                          border: "1px solid #f0f0f0",
                          minHeight: 110,
                          cursor: "pointer",
                        }}
                        bodyStyle={{
                          padding: 16,
                          display: "flex",
                          flexDirection: "column",
                          gap: 10,
                        }}
                      >
                        <div
                          style={{
                            width: 42,
                            height: 42,
                            borderRadius: 12,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            background: `${item.color}12`,
                            color: item.color,
                            fontSize: 20,
                          }}
                        >
                          {item.icon}
                        </div>
                        <div
                          style={{
                            fontSize: 14,
                            fontWeight: 600,
                            color: "#262626",
                            lineHeight: 1.45,
                          }}
                        >
                          {item.title}
                        </div>
                      </Card>
                    </Col>
                  ))}
                </Row>
              )}
            </Card>
          </div>
        )}
        {["8", "12"].includes(this.props.user.role) && (
          <div>
            {/* Full Width Top Card */}
            <Card
              style={{
                marginBottom: 20,
                borderRadius: 10,
              }}
            >
              <Row
                align="middle"
                justify="space-between"
                style={{ cursor: "pointer" }}
                onClick={() =>
                  this.setState((prevState) => ({
                    onlineUsersAccordionOpen:
                      !prevState.onlineUsersAccordionOpen,
                  }))
                }
              >
                <Col>
                  <div
                    style={{
                      fontSize: 18,
                      fontWeight: 600,
                      display: "flex",
                      alignItems: "center",
                      gap: 10,
                    }}
                  >
                    <UserOutlined />
                    Online Users
                    {this.state.onlineUsersAccordionOpen ? (
                      <UpOutlined style={{ fontSize: 14, color: "#595959" }} />
                    ) : (
                      <DownOutlined
                        style={{ fontSize: 14, color: "#595959" }}
                      />
                    )}
                  </div>
                </Col>

                <Col>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      gap: "14px",
                      padding: "8px 14px",
                      borderRadius: "10px",
                      background: "linear-gradient(135deg, #f0f5ff, #ffffff)",
                      border: "1px solid #adc6ff",
                      minWidth: "210px",
                      boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
                    }}
                  >
                    {/* Count Section */}
                    <span
                      onClick={(e) => {
                        e.stopPropagation();
                        this.handleClick();
                      }}
                      style={{
                        fontWeight: 700,
                        fontSize: "15px",
                        cursor: "pointer",
                        color: "#10239e",
                        display: "flex",
                        alignItems: "center",
                        gap: "6px",
                      }}
                    >
                      🟢 {totalOnlineUsers ?? 0} Online Users
                    </span>
                  </div>
                </Col>
              </Row>
            </Card>

            {this.state.onlineUsersAccordionOpen && (
              <Table
                bordered
                loading={this.state.loader}
                dataSource={visibleOnlineUsers || []}
                columns={columns}
                rowKey={(record, index) => index}
                scroll={{ x: 1000 }}
                pagination={{
                  current: this.state.currentPage,
                  pageSize: this.state.pageSize,
                  total: visibleOnlineUsers?.length || 0,

                  showSizeChanger: true,
                  pageSizeOptions: ["10", "20", "50", "100"],

                  onChange: (page, pageSize) => {
                    this.setState({
                      currentPage: page,
                      pageSize: pageSize,
                    });
                  },
                }}
              />
            )}
          </div>
        )}
        <Modal
          title="Users"
          open={this.state.role2ModalVisible}
          footer={null}
          width={900}
          onCancel={() =>
            this.setState({
              role2ModalVisible: false,
            })
          }
        >
          <Table
            bordered
            dataSource={this.state.selectedRole2Users || []}
            rowKey="user_id"
            pagination={{ pageSize: 5 }}
            columns={[
              {
                title: "Sr.No",
                key: "srno",
                render: (_, __, index) => index + 1,
              },
              {
                title: "Name",
                dataIndex: "name",
                render: (text, record) => (
                  <Button
                    type="link"
                    onClick={() => this.openUserDetailsModal(record)}
                  >
                    {text}
                  </Button>
                ),
              },
              {
                title: "Phone",
                dataIndex: "phone",
              },
              {
                title: "District",
                dataIndex: "DistrictName",
              },
              {
                title: "Status",
                dataIndex: "online_status",
                render: (status) => (
                  <Tag color={status === "ONLINE" ? "green" : "red"}>
                    {status}
                  </Tag>
                ),
              },
              {
                title: "Login Details",
                key: "login_details",
                render: (_, record) => (
                  <Button
                    onClick={() =>
                      this.openIpDetailsModal(
                        record?.name,
                        record?.latest_5_ip_details || [],
                      )
                    }
                  >
                    View
                  </Button>
                ),
              },
            ]}
          />
        </Modal>
        <Modal
          title={this.state.selectedIpUserName || "Login Details"}
          open={this.state.ipModalVisible}
          footer={null}
          width={800}
          onCancel={() =>
            this.setState({
              ipModalVisible: false,
            })
          }
        >
          <Table
            bordered
            dataSource={this.state.ipDetails || []}
            rowKey="id"
            pagination={false}
            columns={[
              {
                title: "Sr.No",
                render: (_, __, index) => index + 1,
              },
              {
                title: "IP Address",
                dataIndex: "ip_address",
              },
              {
                title: "Logout Time",
                dataIndex: "updatedAt",
                render: (text) =>
                  text
                    ? new Date(text).toLocaleString("en-IN", {
                        timeZone: "Asia/Kolkata",
                        year: "numeric",
                        month: "2-digit",
                        day: "2-digit",
                        hour: "2-digit",
                        minute: "2-digit",
                        second: "2-digit",
                        hour12: true,
                      })
                    : "-",
              },
            ]}
          />
        </Modal>
        <Drawer
          title={`${this.state.cityName}-Snapshots`}
          footer={null}
          width="90%"
          destroyOnClose
          open={this.state.viewSnapshot}
          onClose={() =>
            this.setState({
              viewSnapshot: false,
              selectedId: null,
              cityName: null,
            })
          }
        >
          <UserSnapShots
            key={this.state.selectedId || "snapshot"}
            selectedCityId={this.state.viewSnapshot && this.state.selectedId}
          />
        </Drawer>
        <Modal
          title="User Details"
          open={this.state.userDetailModalVisible}
          footer={null}
          width={900}
          destroyOnClose
          onCancel={() =>
            this.setState({
              userDetailModalVisible: false,
              selectedUserDetail: null,
            })
          }
        >
          {this.state.selectedUserDetail ? (
            <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
              <div style={{ fontWeight: 700, fontSize: 16 }}>
                {this.state.selectedUserDetail?.name || "—"}
              </div>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                  gap: 10,
                }}
              >
                <div>
                  <strong>Phone:</strong>{" "}
                  {this.state.selectedUserDetail?.phone || "—"}
                </div>
                <div>
                  <strong>Status:</strong>{" "}
                  {this.state.selectedUserDetail?.online_status || "—"}
                </div>
                <div>
                  <strong>City:</strong>{" "}
                  {this.state.selectedUserDetail?.City || "—"}
                </div>
                <div>
                  <strong>District:</strong>{" "}
                  {this.state.selectedUserDetail?.DistrictName || "—"}
                </div>
                <div>
                  <strong>IP Address:</strong>{" "}
                  {this.state.selectedUserDetail?.ip_address || "—"}
                </div>
                <div>
                  <strong>Last Seen:</strong>{" "}
                  {this.state.selectedUserDetail?.updatedAt
                    ? new Date(
                        this.state.selectedUserDetail.updatedAt,
                      ).toLocaleString("en-IN", {
                        timeZone: "Asia/Kolkata",
                      })
                    : "—"}
                </div>
              </div>

              <div style={{ marginTop: 8, fontWeight: 700 }}>
                Latest Login Details
              </div>
              <Table
                bordered
                size="small"
                dataSource={
                  this.state.selectedUserDetail?.latest_5_ip_details || []
                }
                rowKey={(r, idx) => String(r.id ?? idx)}
                pagination={false}
                columns={[
                  {
                    title: "Sr.No",
                    render: (_, __, index) => index + 1,
                    width: 70,
                  },
                  { title: "IP Address", dataIndex: "ip_address" },
                  {
                    title: "Login/Logout Time",
                    dataIndex: "updatedAt",
                    render: (text) =>
                      text
                        ? new Date(text).toLocaleString("en-IN", {
                            timeZone: "Asia/Kolkata",
                            year: "numeric",
                            month: "2-digit",
                            day: "2-digit",
                            hour: "2-digit",
                            minute: "2-digit",
                            second: "2-digit",
                          })
                        : "-",
                  },
                ]}
              />
            </div>
          ) : (
            <div>डेटा उपलब्ध नाही</div>
          )}
        </Modal>

        <Button
          title="Help & Support"
          className="floating-help-btn"
          type="primary"
          shape="circle"
          icon={<QuestionCircleOutlined />}
          onClick={() => this.props.history.push("/faq")}
        />
      </>
    );
  }
}

function mapStateToProps(state) {
  const { users, authentication, professionals } = state;
  const { user } = authentication;
  return {
    user,
    professionals,
  };
}

const connectedDashboard = connect(mapStateToProps)(Dashboard);
export { connectedDashboard as Dashboard };
